<template>
    <div class="about li_none_style">
        <banner :bannerObj="banner"/>
        <div class="container">
            <div class="about_content content">
                <div class='about_section_wedo'>
                    <div class='heading'>How We Do...</div>

                    <div class='flex-container products_flex-container gear'>
                        <img src="../assets/images/Trello.png"/>
                        <img src="../assets/images/Gitlab.png"/>
                        <img src="../assets/images/KM.png"/>
                        <img src="../assets/images/Slack.png"/>
                    </div>

                </div>
                <div class="about-partner">
                    <div class="heading">合作夥伴</div>
                    <ul>
                        <li v-for="(item, index) in CB_partners"
                            :key="index">
                            <img :src="item"/>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="u_div_space">
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from '@/components/Banner.vue'

    export default {
        name: 'About',
        components: {
            'banner': Banner,
        },
        data() {
            return {
                bigScreen: true,
                productItem: [],
                banner: {
                    title: '關於雲灣',
                    info: '我們是一群對軟體服務充滿熱情的夢想家，期望提供使用者<br/>最好的資訊應用體驗；面對新世紀，資訊系統，已不再單純<br/>只是處理資料的工具，更應著眼於以人為導向的服務價值。',
                    img: new URL('../assets/images/2x/about@2x.png', import.meta.url).href
                },
                CB_partners: [
                    new URL('../assets/images/logo_CWB.png', import.meta.url).href,
                    new URL('../assets/images/logo_frims.png', import.meta.url).href,
                    new URL('../assets/images/logo_TPW.png', import.meta.url).href,
                    new URL('../assets/images/logo_manysplendid.jpg', import.meta.url).href,
                    new URL('../assets/images/logo_weatherangel.png', import.meta.url).href,
                    new URL('../assets/images/logo_EPA.png', import.meta.url).href,
                    new URL('../assets/images/logo_CCU.png', import.meta.url).href,
                    new URL('../assets/images/logo_Talent-Taiwan.png', import.meta.url).href,
                    new URL('../assets/images/logo_NDC.png', import.meta.url).href,
                ]
            }
        },
        methods: {
            screen_sencor() {
                if (window.innerWidth > 768) {
                    this.bigScreen = true;
                }
                else {
                    this.bigScreen = false;
                }
            },
        },
        beforeMount() {
            this.screen_sencor()
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.screen_sencor()
                });
            })
        }
    }
</script>

<style>

.gear img {
  width: 50%;
  padding: 2%;
}
@media screen and (max-width: 700px){
  .gear img {
    width: 100%;
  }
}

</style>
